import { Injectable } from '@angular/core';
import { LegacyBaseApiService } from '@smartera/core';
import { Urls } from '@core/config/urls';
import { AsyncOperationDataDetail } from '@api/models/general/async-operation-data';
import { Observable } from 'rxjs';

@Injectable()
export class AnalyticAsyncOperationDataService extends LegacyBaseApiService<any> {
	override get apiUrl() {
		return Urls.BASE_URL.toString() + '/analytic/app/async-operation-data';
	}

	details(id: string): Observable<AsyncOperationDataDetail> {
		return this._restClientService.get(`${this.apiUrl}/${id}/details`);
	}
}
